namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.AddonGrid')
    export class AddonGrid extends Serenity.EntityGrid<AddonRow, any> {
        protected getColumnsKey() { return AddonColumns.columnsKey; }
        protected getDialogType() { return AddonDialog; }
        protected getIdProperty() { return AddonRow.idProperty; }
        protected getInsertPermission() { return AddonRow.insertPermission; }
        protected getLocalTextPrefix() { return AddonRow.localTextPrefix; }
        protected getService() { return AddonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
    }
}